import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const procedureEditGeneratedRoute: RouteConfig = {
  path: 'generate/edit/:attachmentId',
  name: 'procedureEditGenerated',
  component: () =>
    import(/* webpackChunkName: "ProcedureGenerate" */ '@/views/mainRoute/document/details/EditGenerated.vue'),
  meta: { breadcrumb: { title: 'Generowanie dokumentacji' } },
  beforeEnter: (to, from, next) => {
    store.dispatch('procedure/attachment/get', tryParseInt(to.params.attachmentId)).then(() => next());
  }
};
